/* eslint-disable @typescript-eslint/no-explicit-any */
import { ChevronLeft, ChevronRight, MapPin, Phone } from "lucide-react"; //commented out ChevronLeft, ChevronRight from here
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { useCallback, useEffect, useRef, useState } from "react";
import axiosInstance from "@/api/axios";
import TypographyH1 from "@/components/typography/TypographyH1";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import { useLoading } from "@/contexts/LoadingContext";
import DetailSkeleton from "./skeleton-details";
import { Button } from "@/components/ui/button";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "@/store";
import { Link, useNavigate } from "react-router-dom";
import { saveProjectLead } from "@/features/map-view/mapSlice";
// import { TypographyP } from "@/components/typography/TypographyP";
import { formatPrice } from "@/features/kanban/services/KanbanService";
// import ProjectCard from "@/pages/home/ui/project-card";
import { FaMapLocationDot } from "react-icons/fa6";
// import ProjectCard from "@/pages/home/ui/project-card";
import ProjectCard from "../ui/ProjectCard";
import { ProjectLead } from "../types";
import React from "react";
// import { boolean } from "zod";
import {
  addToWatchList,
  removeFromWatchList,
} from "../services/ProjectService";
import toastService from "@/services/toastService";
import { TypographyP } from "@/components/typography/TypographyP";
// import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";

const labelStyle = "text-sm text-[#828282]";

const ProjectDetails = ({
  id,
  view,
}: {
  id: string;
  view: "mapView" | "listView" | undefined;
}) => {
  const [details, setDetails] = useState<any>();
  const dispatch = useDispatch<AppDispatch>();
  const { setLoading } = useLoading();
  const navigate = useNavigate();
  const [leadId, setLeadId] = useState(id);
  const [open, setOpen] = useState(false);
  const [phoneDropdownOpen, setPhoneDropdownOpen] = useState(false);
  const [isWatchlisted, setIsWatchlisted] = useState(
    details?.builderAddedToWatchlist ?? false
  );

  console.log("view Log", view);
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
        setPhoneDropdownOpen(false);
      }
    };

    if (open || phoneDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open, phoneDropdownOpen]);

  const leadIds = useSelector(
    (state: RootState) => state.rootReducer.mapViewReducer.lead_ids
  );

  // const [updated, setUpdated] = useState(false);
  // const toggleUpdated = () => {
  //   setUpdated(!updated);
  // };
  // const getProjectLeadDetails = useCallback(async (params: object) => {
  //   // console.log("get project leads", params, data);
  //   try {
  //     setLoading(true);
  //     const response = await axiosInstance({
  //       method: "GET",
  //       url: "/odoo/api/v1/projects",
  //       params: params,
  //     });

  //     console.log("response", response);

  //     return response;
  //   } catch (err) {
  //     console.log("err", err);
  //   } finally {
  //     setLoading(false);
  //   }
  // }, []);
  useEffect(() => {
    setIsWatchlisted(details?.builderAddedToWatchlist ?? false);
  }, [details?.builderAddedToWatchlist]);

  const getLeadDetails = useCallback(async (params: object) => {
    // console.log("get project leads", params, data);
    try {
      setLoading(true);
      const response = await axiosInstance({
        method: "POST",
        url: "/odoo/api/v1/projectLeads/getDetails",
        data: params,
      });

      console.log("response", response);

      return response;
    } catch (err) {
      console.log("err", err);
    } finally {
      setLoading(false);
    }
  }, []);

  console.log(details);

  useEffect(() => {
    let response;
    const getResponse = async () => {
      response = await getLeadDetails({
        id: +leadId,
        lead_ids: leadIds,
      });
      if (response && response.status == 200) {
        setDetails(response.data.data);
      }
      console.log("details response", response);
    };

    getResponse();
  }, [leadId, getLeadDetails, leadIds]);

  useEffect(() => {
    if (!details?.project_image_ids || details?.project_image_ids.length <= 0) {
      const temp = { ...details };
      temp.project_image_ids = [
        {
          id: 0,
          image_url:
            "https://acropolis-wp-content-uploads.s3.us-west-1.amazonaws.com/Building-Types-Hero.webp",
        },
      ];
      setDetails(temp);
    }
  }, [details]);

  const saveLead = useCallback(async () => {
    if (details.starred) {
      if (details.crm_lead_id) {
        navigate(`/dashboard/leads/${details.crm_lead_id}`);
      }
      return;
    }

    setLoading(true);
    await dispatch(saveProjectLead({ leadId: Number(id) }));
    const updatedResponse = await getLeadDetails({ id: Number(leadId) });
    if (updatedResponse && updatedResponse.status === 200) {
      setDetails(updatedResponse.data.data); // Update details after saving
    }
    setLoading(false);
  }, [details, dispatch, navigate, setLoading, id]);

  const handleToggle = () => {
    const newStatus = !isWatchlisted;
    setIsWatchlisted(newStatus); // update UI immediately

    toggleWatchlist(details.builder.id, {
      status: newStatus,
      action: newStatus ? "enable" : "disable",
    });
  };

  const toggleWatchlist = useCallback(
    async (
      builder_id: number,
      newStatus: { status: boolean; action: string }
    ) => {
      if (newStatus.action === "enable") {
        const response = await addToWatchList(builder_id);

        if (response.statusCode === 201) {
          toastService.success(response.message);
        }
      } else if (newStatus.action === "disable") {
        const response = await removeFromWatchList(builder_id);
        if (response.statusCode === 200) {
          toastService.success(response.message);
        }
      }
    },
    [] // Add dependencies if needed
  );

  return (
    <div className="w-full h-full">
      {details ? (
        <div className="w-full h-full">
          <div className="flex justify-between items-center mb-2 pl-2 pr-3">
            <div>
              {/* Name */}
              <div>
                {/* <div className="flex items-start justify-between"> */}
                <TypographyH1 className="!text-[22px] leading-tight font-bold">
                  {/* {details?.display_name || details?.name} */}
                  {details?.builder?.company_details?.name
                    ? details.builder.company_details.name
                    : details?.applicant_company
                      ? details.applicant_company
                      : details?.owner_company
                        ? details.owner_company
                        : details?.address}
                </TypographyH1>
                {/* </div> */}
              </div>
              {/* Address */}
              {details?.address && (
                <div className="flex items-center gap-1 text-muted-foreground text-sm">
                  <MapPin className="h-4 w-4" />
                  <span>{details?.address}</span>
                </div>
              )}
            </div>

            <div className="flex items-center justify-between gap-4">
              {/* Watch Builder Toggle */}
              {details?.builder && (
                <div className="flex items-center gap-2">
                  <div className={labelStyle}>Watch</div>
                  <button
                    className={`w-10 h-6 rounded-full flex items-center px-1 transition-colors duration-300 ${
                      isWatchlisted ? "bg-green-500" : "bg-gray-400"
                    }`}
                    onClick={handleToggle}
                  >
                    <div
                      className={`w-5 h-5 bg-white rounded-full shadow-md transition-transform duration-300 ${
                        isWatchlisted ? "translate-x-4" : "translate-x-0"
                      }`}
                    />
                  </button>
                </div>
              )}

              {/* Linking Leads Navigation */}
              {details.linking_leads && view === "listView" && (
                <div className="flex gap-2 items-center">
                  <TypographyP className="text-[14px] text-slate-500">
                    {details.linking_leads.current} /{" "}
                    {details.linking_leads.count}
                  </TypographyP>
                  <div className="flex gap-1">
                    <Button
                      onClick={() =>
                        setLeadId(details.linking_leads.previousLeadId)
                      }
                      variant="secondary"
                      size="sm"
                      className="p-1"
                      title="Go to previous lead"
                    >
                      <ChevronLeft />
                    </Button>
                    <Button
                      onClick={() =>
                        setLeadId(details.linking_leads.nextLeadId)
                      }
                      variant="secondary"
                      size="sm"
                      className="p-1"
                      title="Go to next lead"
                    >
                      <ChevronRight />
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="relative grid grid-cols-2">
            <div>
              <Carousel
                opts={{
                  align: "center",
                  loop: true,
                }}
              >
                <CarouselContent>
                  {details?.project_image_ids &&
                    details.project_image_ids?.map(
                      (img: { id: number; image_url: string }, ind: number) => (
                        <CarouselItem key={ind} className="relative">
                          <img
                            src={
                              img.image_url
                                ? img.image_url
                                : `https://v0.dev/placeholder.svg?height=400&width=800`
                            }
                            alt="Construction site"
                            width={800}
                            height={300}
                            className="w-full h-[300px] object-cover rounded-lg"
                          />
                        </CarouselItem>
                      )
                    )}
                </CarouselContent>
                {details?.details_image_ids && details.project_image_ids?.length > 1 && (
    <>
      <CarouselPrevious className="absolute left-2 bg-white/80 hover:bg-white" />
      <CarouselNext className="absolute right-2 bg-white/80 hover:bg-white" />
     </>
  )}
              </Carousel>
            </div>
            <div className="space-y-4 p-3">
              <div className="grid gap-3 md:grid-cols-2 lg:grid-cols-2 mt-5">
                {details?.cost_of_construction !== undefined &&
                  details?.cost_of_construction !== null && (
                    <Card>
                      <CardContent className="p-4">
                        <div className="text-sm text-muted-foreground">
                          Cost of Construction
                        </div>
                        <div className="text-md font-bold">
                          {details?.cost_of_construction === 0
                            ? "$0"
                            : "$" + formatPrice(details.cost_of_construction)}
                        </div>
                      </CardContent>
                    </Card>
                  )}

                {details?.permit_issue_date && (
                  <Card>
                    <CardContent className="p-4">
                      <div className="text-sm text-muted-foreground">
                        Permit Issued
                      </div>
                      <div className="text-md font-bold">
                        {details?.permit_issue_date
                          ? details?.permit_issue_date
                          : "N/A"}
                      </div>
                    </CardContent>
                  </Card>
                )}

                {details?.project_class_id?.[1] && (
                  <Card>
                    {details?.project_class_id &&
                      details.project_class_id?.[1] !== "N/A" && (
                        <CardContent className="p-4">
                          <div className="text-sm text-muted-foreground">
                            Category
                          </div>
                          <div className="text-md font-bold">
                            {details.project_class_id?.[1]}
                          </div>
                        </CardContent>
                      )}
                  </Card>
                )}
                {details?.project_status_id?.[0] && (
                  <Card>
                    <CardContent className="p-4">
                      <div className="text-sm text-muted-foreground">
                        Status
                      </div>
                      <div className="text-md font-bold">
                        {details?.project_status_id &&
                          `${details?.project_status_id?.[1]}`}
                      </div>
                    </CardContent>
                  </Card>
                )}
                {details?.project_type_id?.[1] && (
                  <Card>
                    {details?.project_type_id &&
                      details.project_type_id?.[1] !== "N/A" && (
                        <CardContent className="p-4">
                          <div className="text-sm text-muted-foreground">
                            Project Type
                          </div>
                          <div className="text-md font-bold">
                            {details.project_type_id?.[1]}
                          </div>
                        </CardContent>
                      )}
                  </Card>
                )}
              </div>

              <div className="w-full flex gap-3">
                <div className="w-[50%]">
                  {details.starred ? (
                    <Link to={`/dashboard/leads/${details.crm_lead_id}`}>
                      <Button className="w-full">Go to CRM </Button>
                    </Link>
                  ) : (
                    <Button className="w-full" onClick={saveLead}>
                      Add to CRM
                    </Button>
                  )}
                </div>
                <div className="w-[50%]">
                  {(details?.builder?.phone ||
                    details?.builder?.email ||
                    details?.owner_phone ||
                    details?.owner_email ||
                    details?.applicant_phone ||
                    details?.applicant_email) && (
                    <div className="relative" ref={dropdownRef}>
                      {/* Contact Button */}
                      <Button
                        className="w-full bg-bmpGreen-500 text-white font-semibold hover:bg-bmpGreen-300 active:bg-bmpGreen-500 focus:bg-bmpGreen-500"
                        onClick={() => setOpen(!open)}
                      >
                        Contact
                      </Button>

                      {/* Main Dropdown Menu */}
                      {open && (
                        <div className="absolute top-full mt-2 flex flex-col gap-2 bg-white border shadow-lg z-[2000] w-[200px] left-1/2 transform -translate-x-1/2 p-2 rounded-lg">
                          {/* Call Button */}
                          {(details?.builder?.phone ||
                            details?.owner_phone ||
                            details?.applicant_phone) && (
                            <div className="relative">
                              <Button
                                className="bg-white text-black border w-full hover:bg-slate-300 active:bg-white focus:bg-slate-300"
                                onClick={() =>
                                  setPhoneDropdownOpen(!phoneDropdownOpen)
                                }
                              >
                                Call
                              </Button>

                              {/* Phone Number Dropdown */}
                              {phoneDropdownOpen && (
                                <div className="absolute top-0 right-full mr-2 p-2 bg-white border shadow-md z-[2100] w-[180px] h-auto text-left rounded-lg">
                                  <p className="text-black text-sm font-semibold mb-1">
                                    Contact
                                  </p>
                                  <div className="flex items-center gap-2">
                                    <Phone className="text-bmpGreen-500 size-4" />
                                    <p className="text-black text-sm font-medium">
                                      {details?.builder?.phone
                                        ? details?.builder?.phone
                                        : details?.applicant_phone
                                          ? details?.applicant_phone
                                          : details?.owner_phone}
                                    </p>
                                  </div>
                                </div>
                              )}
                            </div>
                          )}

                          {/* Email Button */}
                          {(details?.builder?.email ||
                            details?.owner_email ||
                            details?.applicant_email) && (
                            <Button
                              className="bg-white text-black border w-full hover:bg-slate-300"
                              onMouseDown={(e) => {
                                e.stopPropagation();
                                window.location.href = `mailto:${
                                  details?.builder?.email ||
                                  details?.owner_email ||
                                  details?.applicant_email
                                }`;
                              }}
                            >
                              Email
                            </Button>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Project Description */}
          <div className="space-y-4 mt-3 mb-1 mr-3">
            {details.project_description && (
              <Card>
                <CardHeader className="mt-0 py-2">
                  <h3 className="text-base text-dark font-semibold leading-normal m-0">
                    PROJECT DESCRIPTION
                  </h3>
                </CardHeader>

                <CardContent className="space-y-4 mt-0">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: details?.project_description || "N/A",
                    }}
                  ></div>
                </CardContent>
              </Card>
            )}
            {/* Project Details */}
            <Card className="mt-0">
              <CardHeader className="mt-0 py-2">
                <h3 className="text-base text-dark font-semibold leading-normal m-0">
                  PROJECT DETAILS
                </h3>
              </CardHeader>
              <CardContent className="space-y-4 mt-0">
                <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                  {/* Month Started */}
                  {/* {details?.month_started && (
                    <div className="space-y-1">
                      <div className={labelStyle}>Month Started</div>
                      <div>
                        {new Date(
                          0,
                          Number(details.month_started) - 1
                        ).toLocaleString("default", { month: "long" })}
                      </div>
                    </div>
                  )} */}
                  {/* Permit Issue Date */}
                  {/* {details?.permit_issue_date && (
                    <div className="space-y-1">
                      <div className={labelStyle}>Permit Issue Date</div>
                      <div>{details.permit_issue_date}</div>
                    </div>
                  )} */}
                  {details?.create_date && (
                    <div className="space-y-1">
                      <div className={labelStyle}>Create Date</div>
                      <div>{details.create_date.split(' ')[0]}</div>
                    </div>
                  )}
                  {/* Project Title */}
                  {details?.display_name && (
                    <div className="space-y-1">
                      <div className={labelStyle}>Project Title</div>
                      <div>{details.display_name}</div>
                    </div>
                  )}
                  {/* Province */}
                  {details?.province_id && (
                    <div className="space-y-1">
                      <div className={labelStyle}>Province</div>
                      <div>{details.province_id[1]}</div>
                    </div>
                  )}
                  {/* Country */}
                  {details?.country_id && (
                    <div className="space-y-1">
                      <div className={labelStyle}>Country</div>
                      <div>{details.country_id[1]}</div>
                    </div>
                  )}
                  {/* City */}
                  {details?.city && (
                    <div className="space-y-1">
                      <div className={labelStyle}>City</div>
                      <div>{details.city}</div>
                    </div>
                  )}
                  {/* Location */}
                  {details?.longitude != "0" && details?.latitude != "0" && (
                    <div className="space-y-1">
                      <div className={labelStyle}>Location</div>
                      <div>
                        <a
                          target="_blank"
                          href={`https://www.google.com/maps/search/?api=1&query=${details.latitude},${details.longitude}`}
                        >
                          <FaMapLocationDot size={22} fill="#28af4a" />
                        </a>
                      </div>
                    </div>
                  )}
                </div>
              </CardContent>
            </Card>
            {/* Category and Project Stage */}
            {/* {(details?.project_class_id ||
              details?.project_status_id ||
              details?.project_type_id) && (
              <Card className="mt-0">
                <CardHeader className="mt-0 py-2">
                  <h3 className="text-base text-dark font-semibold leading-normal m-0">
                    CATEGORY AND PROJECT STAGE
                  </h3>
                </CardHeader>
                <CardContent className="space-y-4 mt-0">
                  <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                 
                    {details?.project_class_id && (
                      <div className="space-y-1">
                        <div className={labelStyle}>Project Class</div>
                        <div>{details.project_class_id[1]}</div>
                      </div>
                    )}

                    {details?.project_status_id && (
                      <div className="space-y-1">
                        <div className={labelStyle}>Project Status</div>
                        <div>{details.project_status_id[1]}</div>
                      </div>
                    )}

                    {details?.project_type_id && (
                      <div className="space-y-1">
                        <div className={labelStyle}>Project Type</div>
                        <div>{details.project_type_id[1]}</div>
                      </div>
                    )}
                  </div>
                </CardContent>
              </Card>
            )} */}
            {/* Builder Details */}
            {details?.builder && (
              <Card className="mt-0">
                <CardHeader className="mt-0 py-2">
                  <h3 className="text-base text-dark font-semibold leading-normal m-0">
                    BUILDER DETAILS
                  </h3>
                </CardHeader>
                <CardContent className="space-y-4 mt-0">
                  <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                    {/* Builder Company */}
                    {details?.builder?.company_details?.name && (
                      <div className="space-y-1">
                        <div className={labelStyle}>Builder Company</div>
                        <div>{details?.builder?.company_details?.name}</div>
                      </div>
                    )}
                    {/* Builder Name */}
                    {details?.builder.name && (
                      <div className="space-y-1">
                        <div className={labelStyle}>Builder Name</div>
                        <div>{details.builder.name}</div>
                      </div>
                    )}
                    {/* Builder Phone */}
                    {details?.builder.phone && (
                      <div className="space-y-1">
                        <div className={labelStyle}>Builder Phone</div>
                        <div>{details.builder.phone}</div>
                      </div>
                    )}
                    {/* Builder Email */}
                    {details?.builder.email && (
                      <div className="space-y-1">
                        <div className={labelStyle}>Builder Email</div>
                        <div className="break-words max-w-xs">{details.builder.email}</div>
                      </div>
                    )}
                    {details?.other_builder_projects && (
                      <div className="space-y-1">
                        <div className={labelStyle}>Builder Projects Count</div>
                        <div>
                          {details?.other_builder_projects?.totalCount + 1}
                        </div>
                      </div>
                    )}
                    {/* {details?.builder &&
                      details.builderAddedToWatchlist !== undefined &&
                      details.builderAddedToWatchlist !== null && (
                        <div className="space-y-1">
                          <div className={labelStyle}>Watch Builder</div>
                          <div className="flex items-center space-x-2">
                            <button
                              className={`w-10 h-6 rounded-full flex items-center px-1 transition-colors duration-300 ${
                                details.builderAddedToWatchlist
                                  ? "bg-green-500"
                                  : "bg-gray-400"
                              }`}
                              onClick={handleToggle}
                            >
                              <div
                                className={`w-5 h-5 bg-white rounded-full shadow-md transition-transform duration-300 ${
                                  details.builderAddedToWatchlist
                                    ? "translate-x-4"
                                    : "translate-x-0"
                                }`}
                              />
                            </button>
                          </div>
                        </div>
                      )} */}
                  </div>
                </CardContent>
              </Card>
            )}
            {/* Owner Details */}
            {(details?.owner_name ||
              details?.owner_email ||
              details?.owner_company ||
              details?.owner_phone) && (
              <Card className="mt-0">
                <CardHeader className="mt-0 py-2">
                  <h3 className="text-base text-dark font-semibold leading-normal m-0">
                    OWNER DETAILS
                  </h3>
                </CardHeader>
                <CardContent className="space-y-4 mt-0">
                  <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                    {/* Owner Company */}
                    {details?.owner_company && (
                      <div className="space-y-1">
                        <div className={labelStyle}>Owner Company</div>
                        <div>{details.owner_company}</div>
                      </div>
                    )}
                    {/* Owner Name */}
                    {details?.owner_name && (
                      <div className="space-y-1">
                        <div className={labelStyle}>Owner Name</div>
                        <div>{details.owner_name}</div>
                      </div>
                    )}
                    {/* Owner Phone */}
                    {details?.owner_phone && (
                      <div className="space-y-1">
                        <div className={labelStyle}>Owner Phone</div>
                        <div>{details.owner_phone}</div>
                      </div>
                    )}
                    {/* Owner Email */}
                    {details?.owner_email && (
                      <div className="space-y-1">
                        <div className={labelStyle}>Owner Email</div>
                        <div className="break-words max-w-xs">{details.owner_email}</div>
                      </div>
                    )}
                    {/* {details?.owner_company && (
                      <div className="space-y-1">
                        <div className={labelStyle}>Owner Company</div>
                        <div>{details.owner_company}</div>
                      </div>
                    )} */}
                  </div>
                </CardContent>
              </Card>
            )}
            {/* Applicant Details */}
            {(details?.applicant_name ||
              details?.applicant_email ||
              details?.applicant_company ||
              details?.applicant_phone) && (
              <Card className="mt-0">
                <CardHeader className="mt-0 py-2">
                  <h3 className="text-base text-dark font-semibold leading-normal m-0">
                    APPLICANT DETAILS
                  </h3>
                </CardHeader>
                <CardContent className="space-y-4 mt-0">
                  <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                    {/* Applicant Company */}
                    {details?.applicant_company && (
                      <div className="space-y-1">
                        <div className={labelStyle}>Applicant Company</div>
                        <div>{details.applicant_company}</div>
                      </div>
                    )}
                    {/* Applicant Name */}
                    {details?.applicant_name && (
                      <div className="space-y-1">
                        <div className={labelStyle}>Applicant Name</div>
                        <div>{details.applicant_name}</div>
                      </div>
                    )}
                    {/* Applicant Phone */}
                    {details?.applicant_phone && (
                      <div className="space-y-1">
                        <div className={labelStyle}>Applicant Phone</div>
                        <div>{details.applicant_phone}</div>
                      </div>
                    )}
                    {/* Applicant Email */}
                    {details?.applicant_email && (
                      <div className="space-y-1">
                        <div className={labelStyle}>Applicant Email</div>
                        <div className="break-words max-w-xs">{details.applicant_email}</div>
                      </div>
                    )}
                    {/* {details?.applicant_company && (
                      <div className="space-y-1">
                        <div className={labelStyle}>Applicant company</div>
                        <div>{details.applicant_company}</div>
                      </div>
                    )} */}
                  </div>
                </CardContent>
              </Card>
            )}
          </div>

          {details?.other_builder_projects &&
            details?.other_builder_projects.projectLeads?.length > 0 && (
              <div className="my-3">
                {/* Heading */}
                <h2 className="text-xl font-bold mb-4 px-2">
                  Other Projects by Builder
                </h2>

                {/* Carousel */}
                <Carousel
                  opts={{
                    align: "start",
                    loop:
                      details.other_builder_projects.projectLeads.length > 1, // Enable looping if more than one project
                  }}
                >
                  <CarouselContent>
                    {details.other_builder_projects.projectLeads.map(
                      (project: ProjectLead) => (
                        <CarouselItem key={project.id} className="basis-1/3">
                          <ProjectCard
                            lead={project}
                            className=""
                            showCheckboxes={false}
                          />
                        </CarouselItem>
                      )
                    )}
                  </CarouselContent>

                  {/* Show navigation buttons only if more than one project */}
                  {details.other_builder_projects.projectLeads.length > 3 && (
                    <>
                      <CarouselPrevious className="absolute left-2 bg-white/80 hover:bg-white" />
                      <CarouselNext className="absolute right-2 bg-white/80 hover:bg-white" />
                    </>
                  )}
                </Carousel>
              </div>
            )}
        </div>
      ) : (
        <DetailSkeleton />
      )}
    </div>
  );
};

export default React.memo(ProjectDetails);
